export default "__VITE_ASSET__D7AkT6Ex__"